import { render, staticRenderFns } from "./DuplicateFolderModal.vue?vue&type=template&id=26574cfa&scoped=true"
import script from "./DuplicateFolderModal.vue?vue&type=script&lang=js"
export * from "./DuplicateFolderModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicateFolderModal.vue?vue&type=style&index=0&id=26574cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26574cfa",
  null
  
)

export default component.exports